// Copyright 2022, Durable
import React, { useMemo } from "react";
import { Outlet } from "react-router-dom";
import Card from "../components/shared/base/Card";

const year = new Date().getFullYear();

/**
 * A simple component that returns a page copyright.
 *
 * @return {React.ReactElement} JSX representation of durable copyright.
 */
function DurableCopyright() {
  const component = useMemo(
    () => (
      <>
        <Outlet />
        <Card className="fixed bottom-5 left-5 z-10 p-3" tabIndex={-1}>
          <div
            className={`text-coolGrey-400 dark:text-coolGrey-700
        text-xs uppercase`}
          >
            Copyright © {year} Durable
          </div>
        </Card>
      </>
    ),
    []
  );

  return component;
}

export { DurableCopyright };
